import { useCallback, useRef, useState } from 'react'
import { getSafetyRoleCandidates } from 'services/safetyRoleService'

const useSafetyRoleCandidates = scope => {
  const [candidates, setCandidates] = useState([])
  const [state, setState] = useState('idle')
  const scopeType = scope?.type
  const scopeId = scope?.id

  const load = useCallback(async () => {
    if (!scopeId) return
    setState('loading')
    try {
      const res = await getSafetyRoleCandidates({ type: scopeType, id: scopeId })
      setCandidates(res?.data?.data || [])
      setState('loaded')
    } catch (e) {
      setState('error')
    }
  }, [scopeType, scopeId])

  const stateRef = useRef(state)
  stateRef.current = state

  const ensure = useCallback(() => {
    if (stateRef.current === 'idle' || stateRef.current === 'error') load()
  }, [load])

  return { candidates, state, load, ensure }
}

export default useSafetyRoleCandidates
